import React from 'react';

/**
 * Composant PageHeader - En-tête de page standardisé
 *
 * @param {string} icon - Emoji ou icône à afficher
 * @param {string} title - Titre principal de la page
 * @param {string} subtitle - Sous-titre optionnel
 * @param {React.ReactNode} actions - Boutons d'action à droite
 * @param {React.ReactNode} children - Contenu additionnel (filtres, tabs, etc.)
 * @param {string} color - Couleur du thème ('purple', 'blue', 'green', 'orange', 'red', 'teal')
 */
const PageHeader = ({
  icon,
  title,
  subtitle,
  actions,
  children,
  color = 'purple'
}) => {
  // Palettes de couleurs pour le gradient du titre
  const colorThemes = {
    purple: { gradient: 'linear-gradient(135deg, #667eea, #764ba2)', solid: '#667eea' },
    blue: { gradient: 'linear-gradient(135deg, #4facfe, #00f2fe)', solid: '#4facfe' },
    green: { gradient: 'linear-gradient(135deg, #11998e, #38ef7d)', solid: '#11998e' },
    orange: { gradient: 'linear-gradient(135deg, #f093fb, #f5576c)', solid: '#f5576c' },
    red: { gradient: 'linear-gradient(135deg, #eb3349, #f45c43)', solid: '#eb3349' },
    teal: { gradient: 'linear-gradient(135deg, #5ee7df, #b490ca)', solid: '#5ee7df' }
  };

  const theme = colorThemes[color] || colorThemes.purple;

  return (
    <div style={{
      background: 'white',
      padding: 'clamp(15px, 4vw, 25px)',
      borderRadius: '16px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      marginBottom: '20px'
    }}>
      {/* Ligne principale : Titre + Actions */}
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '15px',
        flexWrap: 'wrap'
      }}>
        {/* Titre avec icône */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
          <h2 style={{
            margin: 0,
            fontSize: 'clamp(20px, 4vw, 28px)',
            fontWeight: '700',
            background: theme.gradient,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            {icon && (
              <span style={{
                fontSize: 'clamp(24px, 5vw, 32px)',
                WebkitTextFillColor: 'initial',
                backgroundClip: 'initial',
                background: 'none'
              }}>
                {icon}
              </span>
            )}
            <span>{title}</span>
          </h2>
          {subtitle && (
            <span style={{
              fontSize: '0.9375rem',
              color: '#64748b',
              fontWeight: '400'
            }}>
              {subtitle}
            </span>
          )}
        </div>

        {/* Actions (boutons) */}
        {actions && (
          <div style={{
            display: 'flex',
            gap: '10px',
            flexWrap: 'wrap',
            alignItems: 'center'
          }}>
            {actions}
          </div>
        )}
      </div>

      {/* Contenu additionnel (filtres, tabs, etc.) */}
      {children && (
        <div style={{ marginTop: '20px' }}>
          {children}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
